import login from "../api/login";
import newList from "../api/newList";
import newInfo from "../api/newInfo";

export default {
  login,
  newList,
  newInfo
};
